/**
 * GTES — Global Technical Engineering Services
 * This is the default / fallback company configuration.
 */
import logo from "../../assets/logos/gtes/logo.jpg";

const config = {
  slug: "gtes",
  name: "Global Technical Engineering Services",
  shortName: "GTES",
  tagline: "Timesheet & Project Activity",
  website: "https://gtechengs.com",
  domains: ["gtechengs.com", "www.gtechengs.com", "timesheet.gtechengs.com"],

  brand: {
    primaryColor: "#FF5500",
    secondaryColor: "#1F4E8C",
    accentColor: "#10B981",
    logo,
    favicon: logo,
  },

  contact: {
    email: "info@gtechengs.com",
    phone: "+91 20 0000 0000",
    address: "Pune, Maharashtra\nIndia",
  },

  social: {
    linkedin: "https://www.linkedin.com/company/gtechengs",
    twitter: "",
    facebook: "",
    instagram: "",
    youtube: "",
  },

  hero: {
    title: "Timesheet & Project Activity, built for engineering teams",
    description:
      "Daily entries, weekly submissions, approvals and payroll — all in one secure workspace.",
    primaryCta: "Sign in",
    secondaryCta: "Request access",
  },

  about: {
    headline: "About GTES",
    body: "GTES delivers multidisciplinary engineering services to industrial clients across power, oil & gas, infrastructure and manufacturing sectors.",
    bullets: [
      "Established operations across India & GCC",
      "Multi-disciplinary engineering & BIM",
      "End-to-end project delivery",
    ],
  },

  services: [
    { title: "Engineering Design", description: "Mechanical, piping, structural and electrical design." },
    { title: "3D Modeling & BIM", description: "Detailed 3D models and construction-ready drawings." },
    { title: "Project Management", description: "End-to-end project coordination and delivery assurance." },
  ],

  testimonials: [],
  portfolio: [],

  seo: {
    title: "GTES — Timesheet & Project Activity",
    description:
      "GTES Timesheet & Project Activity Management for engineering teams — daily entries, weekly submissions, approvals and payroll.",
    ogImage: "",
  },

  extras: {
    footerCopyright: "© {YEAR} GTES — Internal Use",
  },
};

export default config;
